export default function Layout({ children, variant = "default" }) {
  return (
    <div
      className={`App min-h-screen flex flex-col box-border ${
        variant === "bg" ? "bg" : ""
      }`}
    >
      {children}
    </div>
  );
}
